import { SET_ANNOTATION_LIST } from './consts';

const ANNOTATIONS_TAG = 'Annotations';

const setAnnotationList = list => {
  return {
    type: SET_ANNOTATION_LIST,
    list
  }
};

const findAnnotation = (list, id) => {
  let index = -1;
  list.forEach((annotation, i) => {
    if (annotation.id === id) index = i;
  });
  return index;
};

export const fetchAnnotations = (layerId, signalTypeId) => {
  return async (dispatch, getState, { apiClient }) => {
    const result = await apiClient.call(ANNOTATIONS_TAG, 'findAll', {layerId, typeId: signalTypeId});
    dispatch(setAnnotationList(result.data));
  };
};

export const createAnnotation = (layerId, dimensionTypeId, body) => {
  return async (dispatch, getState, { apiClient }) => {
    const annotation = await apiClient.call(ANNOTATIONS_TAG, 'create', {layerId, typeId: dimensionTypeId}, body);
    const result = getState().analysis.single.annotations;
    result.push(annotation);
    dispatch(setAnnotationList(result));
  }
};

export const patchAnnotation = (annotationId, payload) => {
  return async (dispatch, getState, { apiClient }) => {
    const result = await apiClient.call(ANNOTATIONS_TAG, 'patch', {id: annotationId}, payload);
    const {annotations} = getState().analysis.single;
    annotations[findAnnotation(annotations, annotationId)] = result;
    dispatch(setAnnotationList(annotations));
  }
};

export const deleteAnnotation = (annotationId) => {
  return async (dispatch, getState, { apiClient }) => {
    const result = await apiClient.call(ANNOTATIONS_TAG, 'delete', { id: annotationId });
    const { annotations } = getState().analysis.single;
    annotations.splice(findAnnotation(annotations, result.id), 1);
    dispatch(setAnnotationList(annotations));
  }
};


// WEBPACK FOOTER //
// ./src/scenes/analysis/data/analysis/annotationsActions.js